module.exports = __webpack_public_path__ + "fibratex.jpg?8c94480681e8cf13f0766f69ab8e9f6b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/fibratex.jpg
// module id = 115
// module chunks = 0